import { useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useGeolocationContext } from "@/contexts/GeolocationContext";
import { GeolocationPermissionState } from "@/services/geolocationService";

export const GeolocationAlert = () => {
  const { t } = useTranslation();
  const { isEnabled, isSupported, permissionState, toggleGeolocation } =
    useGeolocationContext();

  if (!isSupported) {
    return null;
  }

  if (isEnabled) {
    return null;
  }

  if (permissionState === GeolocationPermissionState.GRANTED) {
    return null;
  }

  const handleEnableClick = async () => {
    await toggleGeolocation();
  };

  const getAlertContent = () => {
    if (permissionState === GeolocationPermissionState.DENIED) {
      return {
        title: t("contractorVisits.geolocation.alert.deniedTitle"),
        description: t("contractorVisits.geolocation.alert.deniedDescription"),
        showButton: false,
      };
    }

    return {
      title: t("contractorVisits.geolocation.alert.disabledTitle"),
      description: t("contractorVisits.geolocation.alert.disabledDescription"),
      showButton: true,
    };
  };

  const { title, description, showButton } = getAlertContent();

  return (
    <Alert variant="warning" className="mb-4">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="mt-2">
        <div className="mb-3">{description}</div>
        {showButton && (
          <Button
            onClick={handleEnableClick}
            variant="outline"
            size="sm"
            className="mt-2"
          >
            {t("contractorVisits.geolocation.alert.enableButton")}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
